import { AdminAppState } from '../../state';
import { getSiteViewportHeight } from './get-site-viewport-height';
import { getSiteViewportWidth } from './get-site-viewport-width';

export const getSiteViewportSize = (
  state: AdminAppState,
): { height: number | string; width: number | string } => {
  const height = getSiteViewportHeight(state);
  const width = getSiteViewportWidth(state);
  return { height, width };
};
